import { IRepasseDadosBIRequest } from "../../../Interfaces/Repasse/RepasseDadosBI/RepasseDadosBIInterface";

import Axios from "../../Config/API";
import Service from "../../Service";

export async function InserirDadosRepasseBI(
    requestBody: IRepasseDadosBIRequest
) {
    return Service(
        Axios.post(
            `/repasse/RelatorioRepasse/InserirDadosRepasseBI`,
            requestBody
        )
    );
}
